import React from 'react';

interface BinanceBannerProps {
  referralId?: string;
  referralUrl?: string;
}

export const BinanceBanner: React.FC<BinanceBannerProps> = ({
  referralId = "CPA_00UI0GEENV",
  referralUrl = "https://www.binance.com/activity/referral-entry/CPA?ref=CPA_00UI0GEENV"
}) => {
  return (
    <aside className="dinheuro-binance-banner" style={{
      background: 'linear-gradient(135deg, #181a20 0%, #0b0e11 100%)',
      border: '1px solid #f0b90b',
      borderRadius: '16px',
      padding: '24px',
      color: '#ffffff',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      width: '100%',
      boxShadow: '0 10px 25px rgba(240, 185, 11, 0.15)',
      margin: '20px 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Brilho decorativo no fundo */}
      <div style={{
        position: 'absolute',
        top: '-50px',
        right: '-50px',
        width: '150px',
        height: '150px',
        background: 'rgba(240, 185, 11, 0.12)',
        filter: 'blur(40px)',
        borderRadius: '50%'
      }} />

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        position: 'relative',
        zIndex: 2
      }}>
        {/* Lado Esquerdo: Logo Binance Oficial + Textos */}
        <div style={{ flex: '1 1 300px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '14px', flexWrap: 'wrap' }}>
            {/* Logo Binance Oficial (Vetor Oficial Idêntico à imagem de referência) */}
            <svg
              width="160"
              height="32"
              viewBox="0 0 632.014 126.611"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-label="Logo Binance Oficial"
              style={{ height: '32px', width: 'auto', display: 'block', maxWidth: '175px' }}
            >
              {/* Símbolo do Diamante / Grid Binance */}
              <polygon fill="#F3BA2F" points="38.171,53.203 62.759,28.616 87.36,53.216 101.667,38.909 62.759,0 23.864,38.896" />
              <rect x="3.644" y="53.188" transform="matrix(0.7071 0.7071 -0.7071 0.7071 48.7933 8.8106)" fill="#F3BA2F" width="20.233" height="20.234" />
              <polygon fill="#F3BA2F" points="38.171,73.408 62.759,97.995 87.359,73.396 101.674,87.695 101.667,87.703 62.759,126.611 23.863,87.716 23.843,87.696" />
              <rect x="101.64" y="53.189" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 235.5457 29.0503)" fill="#F3BA2F" width="20.234" height="20.233" />
              <polygon fill="#F3BA2F" points="77.271,63.298 77.277,63.298 62.759,48.78 52.03,59.509 52.029,59.509 50.797,60.742 48.254,63.285 48.254,63.285 48.234,63.305 48.254,63.326 62.759,77.831 77.277,63.313 77.284,63.305" />
              
              {/* Tipografia BINANCE */}
              {/* B */}
              <path fill="#F3BA2F" d="M148.37,30.679h31.117c7.723,0,13.563,1.982,17.521,5.946c3.063,3.07,4.594,6.875,4.594,11.414v0.192 c0,1.918-0.237,3.613-0.714,5.083c-0.476,1.472-1.112,2.797-1.907,3.98c-0.793,1.184-1.715,2.223-2.763,3.117 c-1.049,0.896-2.176,1.664-3.383,2.302c3.882,1.472,6.938,3.469,9.166,5.995c2.227,2.527,3.342,6.028,3.342,10.503v0.191 c0,3.07-0.59,5.755-1.771,8.058c-1.181,2.301-2.873,4.22-5.076,5.755c-2.203,1.535-4.852,2.685-7.948,3.453 c-3.096,0.767-6.527,1.15-10.292,1.15H148.37V30.679z M176.376,57.822c3.262,0,5.852-0.558,7.769-1.678 c1.918-1.119,2.877-2.926,2.877-5.419v-0.192c0-2.237-0.832-3.947-2.494-5.131c-1.663-1.183-4.061-1.775-7.193-1.775h-14.579v14.195 H176.376z M180.309,84.871c3.261,0,5.817-0.59,7.673-1.774c1.854-1.183,2.782-3.022,2.782-5.516V77.39 c0-2.238-0.864-4.012-2.59-5.324c-1.727-1.309-4.508-1.965-8.345-1.965h-17.073v14.771H180.309z" />
              {/* I */}
              <path fill="#F3BA2F" d="M223.875,30.679h14.772v67.141h-14.772V30.679z" />
              {/* N */}
              <path fill="#F3BA2F" d="M261.02,30.679h13.618l31.461,41.34v-41.34h14.579v67.141h-12.564l-32.516-42.682v42.682H261.02V30.679z" />
              {/* A */}
              <path fill="#F3BA2F" d="M365.398,30.2h13.619l28.776,67.62H392.35l-6.139-15.058h-28.391l-6.138,15.058h-15.061L365.398,30.2z M380.936,69.716l-8.921-21.772l-8.918,21.772H380.936z" />
              {/* N */}
              <path fill="#F3BA2F" d="M423.738,30.679h13.621l31.459,41.34v-41.34h14.579v67.141h-12.564l-32.516-42.682v42.682h-14.579V30.679z" />
              {/* C */}
              <path fill="#F3BA2F" d="M536.557,98.97c-4.926,0-9.496-0.896-13.717-2.685s-7.865-4.236-10.934-7.338 c-3.07-3.101-5.469-6.762-7.193-10.982c-1.727-4.221-2.59-8.729-2.59-13.525v-0.191c0-4.796,0.863-9.287,2.59-13.476 c1.725-4.188,4.123-7.865,7.193-11.03c3.068-3.165,6.746-5.66,11.029-7.482s9.018-2.733,14.197-2.733 c3.131,0,5.992,0.257,8.582,0.767c2.59,0.513,4.939,1.215,7.051,2.11c2.111,0.896,4.059,1.983,5.852,3.261 c1.787,1.28,3.451,2.686,4.986,4.221l-9.398,10.838c-2.625-2.365-5.293-4.221-8.01-5.563c-2.719-1.342-5.771-2.014-9.16-2.014 c-2.814,0-5.42,0.544-7.816,1.631c-2.398,1.087-4.461,2.589-6.188,4.507c-1.725,1.918-3.068,4.141-4.029,6.666 c-0.957,2.527-1.436,5.228-1.436,8.105v0.191c0,2.877,0.479,5.596,1.436,8.152c0.961,2.559,2.285,4.796,3.982,6.714 c1.693,1.918,3.74,3.438,6.137,4.557c2.4,1.12,5.037,1.678,7.914,1.678c3.838,0,7.08-0.703,9.734-2.11 c2.654-1.405,5.293-3.324,7.914-5.755l9.4,9.496c-1.727,1.855-3.52,3.518-5.371,4.987c-1.855,1.472-3.885,2.734-6.092,3.79 c-2.205,1.054-4.621,1.855-7.24,2.397C542.756,98.697,539.816,98.97,536.557,98.97z" />
              {/* E */}
              <path fill="#F3BA2F" d="M581.467,30.679h50.547v13.141h-35.967v13.62h31.652v13.14h-31.652v14.1h36.449v13.14h-51.029V30.679z" />
            </svg>

            <span style={{
              background: 'rgba(240, 185, 11, 0.15)',
              color: '#f0b90b',
              fontSize: '11px',
              fontWeight: 700,
              padding: '4px 8px',
              borderRadius: '4px',
              border: '1px solid rgba(240, 185, 11, 0.3)',
              letterSpacing: '0.5px'
            }}>
              PARCEIRO OFICIAL
            </span>
          </div>

          <h4 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: 700, color: '#ffffff', letterSpacing: '-0.3px' }}>
            Abra sua conta na maior corretora de cripto do mundo
          </h4>
          <p style={{ margin: 0, fontSize: '14px', color: '#eaecef', lineHeight: 1.5 }}>
            Compre Bitcoin, Ethereum, Solana e mais de 350 moedas com as menores taxas do mercado.
          </p>
        </div>

        {/* Lado Direito: Botão de Conversão */}
        <div style={{ flex: '0 0 auto', textAlign: 'center' }}>
          <a
            href={referralUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: '#f0b90b',
              color: '#0b0e11',
              fontWeight: 700,
              fontSize: '15px',
              padding: '14px 28px',
              borderRadius: '8px',
              textDecoration: 'none',
              boxShadow: '0 4px 15px rgba(240, 185, 11, 0.4)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#fcd535';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#f0b90b';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Cadastrar na Binance agora &rarr;
          </a>
          <div style={{ marginTop: '8px', fontSize: '11px', color: '#848e9c' }}>
            ID de Indicação: <strong style={{ color: '#f0b90b' }}>{referralId}</strong>
          </div>
        </div>
      </div>
    </aside>
  );
};